import script from "./ServiceContractAnnex2Doc.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceContractAnnex2Doc.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__